import React, { JSX } from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { CssBaseline, ThemeProvider } from '@mui/material';

import { useRestoreConnection } from 'modules/auth';
import { QueryLoading } from 'modules/common/components/QueryLoading';
import { useIsInitializedLocale } from 'modules/i18n';
import { CustomizedSnackbarProvider } from 'modules/notifications';
import { mainTheme } from 'modules/themes';

interface IAppBaseProps {
  children: JSX.Element;
}

export function AppBase({ children }: IAppBaseProps): JSX.Element {
  const isProviderConnectionAttempted = useRestoreConnection();
  const isInitialized = useIsInitializedLocale();

  const muiCache = createCache({
    key: 'mui',
  });

  return (
    <CacheProvider value={muiCache}>
      <ThemeProvider theme={mainTheme}>
        <CssBaseline />

        <CustomizedSnackbarProvider />

        {isInitialized && isProviderConnectionAttempted ? (
          children
        ) : (
          <QueryLoading />
        )}
      </ThemeProvider>
    </CacheProvider>
  );
}
